"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(theme => ({
    root: {
        margin: "5px 0 1px",
        outline: "none",
    },
    editable: {
        cursor: "pointer",
        "&:hover": {
            boxShadow: theme.shadows[3],
        },
    },
    focused: {
        boxShadow: theme.shadows[3],
    },
    centered: {
        textAlign: "center",
    },
    leftAligned: {
        textAlign: "left",
    },
    rightAligned: {
        textAlign: "right",
    },
}), { name: "Media" });
//# sourceMappingURL=styles.js.map